import PropTypes from 'prop-types';
import React from 'react';
import {track} from 'src/utils/analytics';
import CourseCreditStatusText from './course-credit-status-text';
import ProgressCard from './progress-card';

const ctaLink = {
  attributes: {
    href: '/portfolio#courses',
    'aria-label': 'Go to your portfolio and add a course',
    onClick: () => {
      track('college-listing hero-add-courses');
    },
  },
  text: 'Add',
};

class CourseCreditsCard extends React.Component {
  static propTypes = {
    collegeProfile: PropTypes.shape({
      college: PropTypes.shape({
        partnerApplicationDeadlineDay: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        partnerApplicationDeadlineMonth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      }),
    }),
    totalCredits: PropTypes.number.isRequired,
    missingCredits: PropTypes.number.isRequired,
  };

  render() {
    const {totalCredits, missingCredits, collegeProfile} = this.props;
    const text = (
      <CourseCreditStatusText collegeProfile={collegeProfile} missingCredits={missingCredits} />
    );
    return (
      <ProgressCard
        title="Course Credits"
        completed={totalCredits}
        required={15}
        text={text}
        ctaLink={ctaLink}
      />
    );
  }
}

export default CourseCreditsCard;
